import React from 'react';
import { SingleSelection } from '../../../../../components';
import { EnumOperationType } from '../../../../../enum/EnumOperationType';
import { useTranslation } from '../../../../../hooks';
import { translatePrefix } from '../..';
import { EnumTransactionStatus } from '../../../../../enum/EnumTransactionStatus';

interface IProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
}

const StatusSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClear } = props;

  const { translate, tc } = useTranslation();

  return (
    <SingleSelection
      label={label || tc('status')}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      clearSelect={onClear}
      enumData={EnumTransactionStatus}
      nameFn={(name) => translate(`EnumTransactionStatus.${name}`)}
    />
  );
};

export default StatusSingleSelection;
